import { useAppToast } from '../../contexts/AppToastContext.jsx';
import './FeedbackToast.css';

function FeedbackToast() {
  const { toasts, removeToast } = useAppToast();

  if (toasts.length === 0) return null;

  return (
    <div className="feedback-toast-container" aria-live="assertive">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`feedback-toast feedback-toast--${toast.type}`}
          role={toast.type === 'error' ? 'alert' : 'status'}
        >
          <div className="feedback-toast-content">
            <strong className="feedback-toast-title">{toast.title}</strong>
            <p className="feedback-toast-message">{toast.message}</p>
          </div>
          <button
            type="button"
            className="feedback-toast-close"
            onClick={() => removeToast(toast.id)}
            aria-label="Fermer"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}

export default FeedbackToast;
